import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";
import { Link } from "react-router-dom";
import { LogoMark } from "./Logo";

export default function Footer() {
  const [time, setTime] = useState("");

  useEffect(() => {
    const fmt = new Intl.DateTimeFormat("fr-FR", {
      timeZone: "Europe/Paris",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
    const tick = () => setTime(fmt.format(new Date()));
    tick();
    const iv = setInterval(tick, 1000);
    return () => clearInterval(iv);
  }, []);

  const toTop = () => {
    if (window.__lenis) window.__lenis.scrollTo(0);
    else window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="border-t border-black/10 bg-white">
      <div className="mx-auto max-w-7xl px-6 py-16 lg:px-12">
        <div className="flex flex-col justify-between gap-10 md:flex-row md:items-start">
          <div>
            <LogoMark className="h-16 w-16" />
            <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.22em] text-neutral-500">
              Atelier de conception & impression 3D
            </p>
            <p className="mt-2 max-w-xs text-sm leading-relaxed text-neutral-600">
              Atelier basé en France — expédition de fichiers CAO et pièces imprimées en France et
              en Europe.
            </p>
          </div>

          <nav aria-label="Services" className="flex flex-col gap-2 text-sm text-neutral-600">
            <Link to="/modelisation-3d-sur-demande">Modélisation 3D sur demande</Link>
            <Link to="/impression-3d-sur-demande">Impression 3D sur demande</Link>
            <Link to="/creation-stl">Création de fichiers STL</Link>
          </nav>

          <div className="font-mono text-xs text-neutral-500">
            <span className="block uppercase tracking-[0.2em] text-neutral-400">Heure atelier — Paris</span>
            <span className="mt-1 block text-base font-medium tabular-nums text-ink" data-testid="footer-clock">
              {time}
            </span>
          </div>

          <button
            data-testid="footer-back-to-top-button"
            onClick={toTop}
            className="group inline-flex items-center gap-2 rounded-full border border-black/15 px-5 py-2.5 font-mono text-[11px] uppercase tracking-[0.18em] text-neutral-600 transition-colors hover:border-ink hover:text-ink"
          >
            Remonter
            <ArrowUp className="h-3.5 w-3.5 transition-transform group-hover:-translate-y-0.5" />
          </button>
        </div>

        <div className="mt-14 flex flex-col justify-between gap-3 border-t border-black/5 pt-6 text-xs text-neutral-400 sm:flex-row">
          <span>© {new Date().getFullYear()} TroiDéo — Tous droits réservés</span>
          <span>Conception / modélisation 3D sur demande — impression 3D en option</span>
        </div>
      </div>
    </footer>
  );
}
